import { Injectable } from "@angular/core";
import { ViolationItem } from "../types/Violation/ViolationItem";
import { ClientService } from "../services/client.service";
import { ArrayClientRepository } from "./abstract/array.client.repository";

@Injectable({
  providedIn: "root",
})
export class IrefItemRepository extends ArrayClientRepository<ViolationItem> {
  constructor(clientService: ClientService) {
    super(clientService, "schemas.schCFG_IREF_Item.records", "itemID");
  }

  public getIrefItemsByCategoryID(categoryID: string): ViolationItem[] {
    return super.getFilteredByValue("categoryID", categoryID);
  }
}
